import {gql} from "@apollo/client";

export const GET_PROFILE = gql`
  query GetProfile {
    me {
      id
      name
      email
      avatar
      phone
      tradingSince
      tradingFrequency
      website
      tradeStyle
      bio

      payoutMethod {
        id
        name
        email
      }
    }
  }
`;

export const NOTIFICATION_SETTINGS = gql`
  query GetNotificationSettings {
    notificationSettings {
      id
      emailReceipts
      referralAlerts
      newsletter
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($input: MutationUpdateProfileInput!) {
    updateProfile(input: $input) {
      id
    }
  }
`;

export const UPDATE_NOTIFICATION_SETTINGS = gql`
  mutation UpdateNotificationSettings($input: MutationUpdateNotificationSettingsInput!) {
    updateNotificationSettings(input: $input) {
      id
    }
  }
`;

export const UPDATE_PAYOUT_METHOD = gql`
  mutation UpdatePayoutMethod($input: MutationUpdatePayoutMethodInput!) {
    updatePayoutMethod(input: $input) {
      id
    }
  }
`;
